import React, { Component } from "react";
import Header from "../../components/header/Header";
import Greeting from "../../containers/greeting/Greeting";
import WhatIDo from "../../containers/whatIDo/WhatIDo";
import TopButton from "../../components/topButton/TopButton";

class Home extends Component {
  render() {
    return (
      <div>
        <Header
          theme={this.props.theme}
          isDark={this.props.isDark}
          toggleTheme={this.props.toggleTheme}
        />
        <Greeting theme={this.props.theme} />
        <WhatIDo theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Home;
